import React, { useState, useEffect } from "react"
import Image from "next/legacy/image"
import { Layout } from "components/common"
import Link from "next/link"
import { notification } from "components/ui"
import Skeleton from "components/Skeleton"
import { apiPayment } from "api"
import { trackGA } from "lib/func"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import { BreadcrumbSubcription } from "components/Breadcrumb"
import BreadcrumbMobile from "components/Breadcrumb/BreadcrumbMobile"
export default function Subscriptions({ idVideo, deviceType }) {
  console.log({ deviceType })
  const [category, setCategory] = useState([])
  const [activeCategory, setActiveCategory] = useState()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  // const [isShown, setIsShown] = useState(idVideo ? 1 : 2)

  async function getEvent() {
    setLoading(true)
    try {
      const { data, success } = await apiPayment.getCategory()
      if (success) {
        if (data?.length > 0) {
          let ArrayCategory = data.filter((item) => item?.package.length > 0)
          setCategory(ArrayCategory)
          setActiveCategory(ArrayCategory[0].id)
          setRows(ArrayCategory[0]?.package)
        }
      }

      // const { data, success } = await apiPayment.getListPacekage({
      //   type: "SUBS",
      //   league_id: idVideo ? idVideo : undefined
      // })
    } catch (e) {
      if (e) {
        notification.error({ message: e })
      }
      console.log(e)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }
  function onSelectCategory(id) {
    setActiveCategory(id)
    const item = category?.find((i) => i.id === id)
    setRows(item?.package)
  }
  useEffect(() => {
    getEvent()
    trackGA("Danh sách gói cước", "PACKAGE_TAB")
  }, [idVideo])

  return (
    <main className="max-w-screen-xl m-auto px-4 md:px-8 py-4 mb-8 text-dark-100 ">
      <div className="w-full md:px-8 flex items-center mb-8 justify-center mt-4 md:mt-10">
        <div>{deviceType === "desktop" ? <BreadcrumbSubcription step={1} /> : <BreadcrumbMobile step={1} />}</div>
      </div>
      <div className="flex md:justify-center mb-4 overflow-auto">
        <div className="bg-dark rounded flex min-w-[650px]">
          {category?.length > 0 &&
            category?.map(({ name, id }) => {
              const __active = activeCategory === id ? "bg-primary-500 text-gray-900 rounded gradient--button--sub" : ""
              return (
                <button
                  onClick={() => onSelectCategory(id)}
                  className={`h-10 text-dark-300 px-4 mx-1 font-semibold text-sm md:text-lg ${__active}`}
                  key={id}
                >
                  {name}
                </button>
              )
            })}
        </div>
      </div>
      {!loading ? (
        <div>
          {deviceType === "desktop" ? (
            <div className="relative wapper__swiper__custom bg-dark p-2 md:p-8 rounded-lg">
              <Swiper
                key="vod_category"
                slidesPerView={2.8}
                spaceBetween={16}
                navigation={true}
                modules={[Navigation]}
                className="swiper__vatical"
              >
                {rows?.map((item) => {
                  const { description, id, image_uri, name } = item
                  return (
                    <SwiperSlide key={item?.id}>
                      <div className="rounded-xl bg-dark mb-4 flex flex-col justify-between " key={id}>
                        <div className="">
                          <div className="justify-center max-h-56 w-full">
                            <Link href={`/subscription-detail/${id}`} passHref={true}>
                              <Image
                                className="rounded-t-xl cursor-pointer"
                                src={
                                  image_uri ||
                                  "https://i.pinimg.com/originals/8d/95/b1/8d95b17703bce864d84ce874181004bd.jpg"
                                }
                                width={480}
                                height={270}
                              />
                            </Link>
                          </div>
                          <div className="p-8">
                            <div className="text-white font-semibold text-lg mb-2 line-clamp-1">{name}</div>
                            <div
                              className="mb-8 line-clamp-7 h-[170px]"
                              dangerouslySetInnerHTML={{ __html: description?.replace(/\n/g, "<br />") }}
                            />
                            <Link href={`/subscription-detail/${id}`} passHref={true}>
                              <div
                                className={
                                  "rounded w-full bg-primary-500 h-10 space-x-4 hover:bg-primary-hover font-semibold text-dark flex items-center justify-center"
                                }
                              >
                                CHỌN GÓI
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          ) : (
            <div>
              {rows?.map((item) => {
                const { id, image_uri } = item
                return (
                  <div className="rounded-xl bg-dark mb-4" key={id}>
                    <Link href={`/subscription-detail/${id}`} passHref={true}>
                      <Image
                        className="rounded-t-xl cursor-pointer"
                        src={
                          image_uri || "https://i.pinimg.com/originals/8d/95/b1/8d95b17703bce864d84ce874181004bd.jpg"
                        }
                        width={480}
                        height={270}
                      />
                    </Link>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      ) : (
        <Skeleton type="sub" />
      )}

      {/* </LoadingSub> */}
    </main>
  )
}
Subscriptions.Layout = Layout

export async function getServerSideProps({ query, req }) {
  let idVideo = query?.id || ""

  const UA = req.headers["user-agent"]
  const isMobile = Boolean(UA.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))

  let deviceType = isMobile ? "mobile" : "desktop"
  return { props: { idVideo, deviceType } }
}
